import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FC, useCallback } from 'react';
import { FieldArrayWithId } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import EmptyState from './empty-state';
import SectionItemTitle from './container-items';

const useStyles = makeStyles((theme: any) => ({
  // Phones let the page scroll; a bounded list region only from sm.
  list: {
    [theme.breakpoints.up('sm')]: {
      maxHeight: theme.spacing(37.5),
      overflowY: 'auto',
    },
  },
  row: {
    display: 'flex',
    gap: theme.spacing(1),
    paddingBottom: theme.spacing(0.5),
  },
  element: {
    flex: 1,
    minWidth: 0,
    overflowWrap: 'anywhere',
  },
  kind: { color: theme.palette.text.secondary },
}));

type PermissionsSectionProps = {
  permissions: FieldArrayWithId<any, any, any>[];
  onOpenModal: () => void;
  getOptions: (type: string) => any[];
};

const PermissionsSection: FC<PermissionsSectionProps> = ({
  permissions,
  onOpenModal,
  getOptions,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const resolveDescription = useCallback(
    (permission: any) => {
      const currentOptions = getOptions(permission.kind);
      if (permission.kind !== 'role') {
        return (currentOptions as any[]).find((f) => f.code === permission.element)?.description;
      }
      return (currentOptions as any[]).find((f) => f._id === permission.element)?.description;
    },
    [getOptions]
  );

  return (
    <Grid item>
      <SectionItemTitle title={t('contact:permissionsTitle')} onClickIcon={onOpenModal}>
        {permissions.length > 0 ? (
          <div className={classes.list}>
            {permissions.map((permission) => (
              <div key={permission.id} className={classes.row}>
                <Typography variant="body2" className={classes.element}>
                  {resolveDescription(permission) || ''}
                </Typography>
                <Typography variant="body2" className={classes.kind}>{permission.kind}</Typography>
              </div>
            ))}
          </div>
        ) : (
          <EmptyState />
        )}
      </SectionItemTitle>
    </Grid>
  );
};

export default PermissionsSection;
